<template lang="pug">
  v-select(
    :value="value"
    :items="courseResources.level"
    item-value="value"
    item-text="title"
    name="level_type"
    label="Уровень сложности"
    filled
    rounded
    v-bind="$attrs"
    @input="$emit('input', $event)"
  )
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CourseLevel',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(['courseResources']),
  },
  created() {
    if (!this.courseResources.level) {
      this.$store.dispatch('GET_RESOURCES');
    }
  },
};
</script>
